/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ki_Feedback_LoadingInputs */

const en_ki_feedback_loading = /** @type {(inputs: Ki_Feedback_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading AI feedback...`)
};

const de_ki_feedback_loading = /** @type {(inputs: Ki_Feedback_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Feedback wird geladen ...`)
};

/**
* | output |
* | --- |
* | "Loading AI feedback..." |
*
* @param {Ki_Feedback_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ki_feedback_loading = /** @type {((inputs?: Ki_Feedback_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ki_Feedback_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ki_feedback_loading(inputs)
	return en_ki_feedback_loading(inputs)
});